import React, { useState, useEffect } from 'react';
import Breadcrumb from '../components/Common/Breadcrumb';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter } from '../components/ui/dialog';
import { connect } from 'react-redux';
import { DatePickerField } from '../components/ui/date-picker-field';
import { AnnouncementAlert } from '../components/Common/ReusableComponents/Reusable';
import { Actions as ADMINACTIONS } from '../store/actions/adminActions';
import ACTIONS from '../store/action';
import Select from 'src/components/ui/BrandSelect';
import { X, AlignLeft, AlignCenter, LayoutList, List, Pencil, Trash2 } from 'lucide-react';
import _ from 'lodash';

const AnnouncementModal = ({
  setShowModal,
  item,
  action,
  saveAnnouncement,
  deleteAnnouncement,
  getAllItemsFromDB,
  wlOptions,
  wlAdmin,
  cyfAdmin,
  user,
}) => {
  const [state, setState] = useState(item || {});
  const [dialog, setDialog] = useState(false);
  const options = [
    { label: 'All Users', value: 'all' },
    { label: 'White Label / Consultant Admins', value: 'admins' },
    { label: 'White Labels', value: 'whitelabels' },
  ];

  const savingAnnouncement = async () => {
    const modifiedDate = new Date();
    const createdDate = new Date();
    const modifiedBy = user?.userSub;
    const createdBy = user?.userSub;

    if (wlAdmin) {
      if (state?.id) {
        await saveAnnouncement({
          announcement: {
            ...state,
            modifiedBy: modifiedBy,
            modifiedDate: modifiedDate,
          },
        });
      } else {
        await saveAnnouncement({
          announcement: {
            ...state,
            targetAudience: 'whitelabels',
            whiteLabels: [wlAdmin],
            createdBy: createdBy,
            createdDate: createdDate,
            editableBy: wlAdmin,
          },
        });
      }
    } else {
      if (state?.id) {
        await saveAnnouncement({ announcement: { ...state, modifiedBy: modifiedBy, modifiedDate: modifiedDate } });
      } else {
        await saveAnnouncement({
          announcement: {
            ...state,
            createdBy: createdBy,
            createdDate: createdDate,
          },
        });
      }
    }
    setShowModal({ status: false });
    await getAllItemsFromDB('announcements', null, true);
  };

  const handleCloseModal = () => setShowModal({ status: false });

  if (action === 'delete') {
    return (
      <Dialog open={true} onOpenChange={(open) => !open && handleCloseModal()}>
        <DialogContent onClose={handleCloseModal} className='max-w-md p-0 bg-card'>
          <DialogHeader className='px-6 pt-6 pb-4 pr-14 border-b border-border'>
            <DialogTitle className='font-display text-lg'>Delete Announcement</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <p className='text-sm text-foreground'>Are you sure you want to delete this announcement?</p>
          </DialogBody>
          <DialogFooter className='border-t border-border'>
            <Button type='button' variant='outline' onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              type='button'
              variant='destructive'
              onClick={async () => {
                handleCloseModal();
                await deleteAnnouncement(item?.id);
                await getAllItemsFromDB('announcements', null, true);
              }}>
              Delete Announcement
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={true} onOpenChange={(open) => !open && handleCloseModal()}>
      <DialogContent
        onClose={handleCloseModal}
        className='max-w-4xl max-h-[90vh] overflow-y-auto p-0 bg-card'>
        <DialogHeader className='px-6 pt-6 pb-4 pr-14 border-b border-border'>
          <DialogTitle className='font-display text-lg'>{item ? 'Edit Announcement' : 'Add Announcement'}</DialogTitle>
        </DialogHeader>
        <DialogBody className='max-h-[min(75vh,720px)] overflow-y-auto'>
            <div className='form-group mb-4'>
              <label>Preview:</label>
              <AnnouncementAlert item={{ ...state }} />
            </div>
            <div>
              <div className='form-group mb-4'>
                <label>
                  Text: *
                  <Button variant='link' className='p-1 ml-2 h-auto' onClick={() => setDialog(true)}>
                    Add Link
                  </Button>
                </label>
                <div className='flex flex-row items-center gap-2'>
                  <textarea
                    className='flex min-h-[80px] w-full rounded-lg border-[1.5px] border-input bg-transparent px-3.5 py-2 text-sm'
                    value={state?.text || ''}
                    onChange={(e) => setState({ ...state, text: e?.target?.value })}></textarea>
                  <div className="flex border-none p-0 gap-2" role="group">
                    <Button
                      type="button"
                      variant={state?.alignment === 'left' ? 'default' : 'outline'}
                      size="icon"
                      onClick={() => setState({ ...state, alignment: 'left' })}>
                      <AlignLeft size={20} strokeWidth={1.5} />
                    </Button>
                    <Button
                      type="button"
                      variant={state?.alignment === 'center' ? 'default' : 'outline'}
                      size="icon"
                      onClick={() => setState({ ...state, alignment: 'center' })}>
                      <AlignCenter size={20} strokeWidth={1.5} />
                    </Button>
                  </div>
                </div>
                <Dialog open={dialog} onOpenChange={(open) => !open && setDialog(false)}>
                  <DialogContent
                    className='max-w-md p-0 bg-card'
                    onClose={() => setDialog(false)}>
                    <DialogHeader className='px-6 pt-6 pb-4 pr-14 border-b border-border'>
                      <DialogTitle className='font-display text-lg'>Add Link</DialogTitle>
                    </DialogHeader>
                    <DialogBody className='flex flex-col gap-3'>
                      <p className='text-sm text-muted-foreground'>Link name (shown as clickable text):</p>
                      <Input
                        type='text'
                        value={state?.linkName || ''}
                        onChange={(e) => setState({ ...state, linkName: e?.target?.value })}
                      />
                      <p className='text-sm text-muted-foreground'>Link URL:</p>
                      <Input
                        type='text'
                        value={state?.linkUrl || ''}
                        onChange={(e) => setState({ ...state, linkUrl: e?.target?.value })}
                      />
                      <Button
                        type='button'
                        className='mt-2'
                        onClick={() => {
                          setDialog(false);
                          setState({
                            ...state,
                            text: `${state?.text || ''} <a href="${state?.linkUrl}" target="_blank">${
                              state?.linkName || state?.linkUrl
                            }</a>`,
                          });
                        }}>
                        Add Link
                      </Button>
                    </DialogBody>
                  </DialogContent>
                </Dialog>
              </div>
              <div className='flex flex-row items-center justify-between gap-2'>
                <DatePickerField
                  label='Start Date: *'
                  value={state?.startDate ?? null}
                  onChange={(date) => setState({ ...state, startDate: date })}
                  dateFormat='dd/MM/yyyy h:mm aa'
                  showTimeInput
                  timeInputLabel='Time:'
                  isClearable
                  scrollableYearDropdown
                  yearDropdownItemNumber={5}
                />
                <DatePickerField
                  label='End Date: *'
                  value={state?.endDate ?? null}
                  onChange={(date) => setState({ ...state, endDate: date })}
                  minDate={state?.startDate ?? undefined}
                  dateFormat='dd/MM/yyyy h:mm aa'
                  showTimeInput
                  timeInputLabel='Time:'
                  isClearable
                  scrollableYearDropdown
                  yearDropdownItemNumber={5}
                />
              </div>
            </div>
            <div style={{ display: cyfAdmin ? 'block' : 'none' }}>
              <div className='form-group mb-4'>
                <label>Target Audience: *</label>
                <Select
                  options={options}
                  onChange={(e) => setState({ ...state, targetAudience: e?.value })}
                  placeholder='Select Target Audience'
                  value={options?.find((option) => option.value === state?.targetAudience)}
                />
              </div>
              <div style={{ display: state?.targetAudience === 'whitelabels' ? 'block' : 'none' }} className='form-group'>
                <label>White Labels:</label>
                <Select
                  options={wlOptions}
                  isMulti
                  onChange={(e) => {
                    const selectedWhiteLabels = e?.map((item) => item?.value);
                    setState({ ...state, targetAudience: 'whitelabels', whiteLabels: selectedWhiteLabels });
                  }}
                  placeholder='Select White Labels'
                  value={wlOptions?.filter((option) => state?.whiteLabels?.includes(option?.value))}
                />
              </div>
            </div>
            <div className='customise'>
              <div className='form-group mb-4'>
                <label>Background Color:</label>
                <div className='flex flex-row items-center gap-2'>
                  <input
                    className='h-9 w-full rounded border border-input bg-transparent'
                    type='color'
                    onChange={(e) => setState({ ...state, backgroundColor: e?.target?.value })}
                    value={state?.backgroundColor}
                  />
                  <button
                    className='btn'
                    style={{ backgroundColor: '#BDE5F5', color: 'black' }}
                    onClick={() => {
                      setState({ ...state, backgroundColor: '#BDE5F5' });
                    }}>
                    Info
                  </button>
                  <button
                    className='btn'
                    style={{ backgroundColor: '#8BDA8E', color: 'black' }}
                    onClick={() => {
                      setState({ ...state, backgroundColor: '#8BDA8E' });
                    }}>
                    Success
                  </button>
                  <button
                    className='btn'
                    style={{ backgroundColor: '#FF4D4D', color: 'black' }}
                    onClick={() => {
                      setState({ ...state, backgroundColor: '#FF4D4D' });
                    }}>
                    Danger
                  </button>
                  <button
                    className='btn'
                    style={{ backgroundColor: '#FEE476', color: 'black' }}
                    onClick={() => {
                      setState({ ...state, backgroundColor: '#FEE476' });
                    }}>
                    Warning
                  </button>
                  <button onClick={() => setState({ ...state, backgroundColor: null })}>
                    <X size={20} strokeWidth={1.5} className='ml-2' />
                  </button>
                </div>
              </div>
              <div className='form-group mb-4'>
                <label>Text Color:</label>
                <div className='flex flex-row items-center gap-2'>
                  <input
                    className='h-9 w-full rounded border border-input bg-transparent'
                    type='color'
                    onChange={(e) => setState({ ...state, textColor: e?.target?.value })}
                    value={state?.textColor}
                  />
                  <button className='btn bg-gray-200' onClick={() => setState({ ...state, textColor: '#130834' })}>
                    Deep Purple
                  </button>
                  <button className='btn bg-gray-200' onClick={() => setState({ ...state, textColor: '#FFFFFF' })}>
                    White
                  </button>
                  <button onClick={() => setState({ ...state, textColor: null })}>
                    <X size={20} strokeWidth={1.5} className='ml-2' />
                  </button>
                </div>
              </div>
            </div>
        </DialogBody>
        <DialogFooter className='border-t border-border'>
          <Button type='button' variant='outline' onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            type='button'
            disabled={!state?.text || !state?.startDate || !state?.endDate || (cyfAdmin && !state?.targetAudience)}
            onClick={() => savingAnnouncement()}>
            Save Announcement
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const Announcement = ({
  announcements,
  getAllItemsFromDB,
  saveAnnouncement,
  deleteAnnouncement,
  primaryButton,
  font,
  btnTextColor,
  wlOptions,
  cyfAdmin,
  wlAdmin,
  user,
  buttonHover,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [filters, setFilters] = useState({});
  const [viewType, setViewType] = useState('list');
  const [visibleSections, setVisibleSections] = useState(['upcoming']);
  const [filteredAnnouncements, setFilteredAnnouncements] = useState([]);
  const [upcomingAnnouncements, setUpcomingAnnouncements] = useState([]);
  const [expiredAnnouncements, setExpiredAnnouncements] = useState([]);

  useEffect(() => {
    if (!announcements) {
      getAllItemsFromDB('announcements');
    }
    if (!wlOptions?.length > 0) {
      getAllItemsFromDB('whiteLabelSettings');
    }
  }, []);

  const today = new Date();

  useEffect(() => {
    if (announcements) {
      // Filter announcements based on the selected date in filters
      const filtered = filters?.date
        ? announcements.filter((item) => {
            const selectedDate = new Date(filters.date);
            const startDate = new Date(item.startDate);
            const endDate = new Date(item.endDate);
            return selectedDate >= startDate && selectedDate <= endDate;
          })
        : announcements;

      setFilteredAnnouncements(filtered);

      // Split announcements into upcoming and expired
      const today = new Date();
      const upcoming = filtered.filter((item) => {
        const startDate = new Date(item.startDate);
        const endDate = new Date(item.endDate);
        return (today >= startDate && today <= endDate) || today < startDate;
      });

      const expired = filtered.filter((item) => {
        const endDate = new Date(item.endDate);
        return today > endDate;
      });

      setUpcomingAnnouncements(upcoming);
      setExpiredAnnouncements(expired);
    }
  }, [announcements, filters]);

  function parseAndBuildClickable(str) {
    const regex = /<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/gi;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(str)) !== null) {
      const [fullMatch, href, linkText] = match;
      const idx = match.index;

      // push preceding text
      if (idx > lastIndex) {
        parts.push(str.slice(lastIndex, idx));
      }

      // push clickable span
      parts.push(
        <span
          key={idx}
          onClick={() => window.open(href, '_blank', 'noopener')}
          style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}>
          {linkText}
        </span>,
      );

      lastIndex = idx + fullMatch.length;
    }

    // trailing text
    if (lastIndex < str.length) {
      parts.push(str.slice(lastIndex));
    }

    return parts;
  }

  return (
    <>
      <Breadcrumb items={[{ label: 'Announcements', link: '/admin/announcement' }]} />

      <div className='row'>
        <div className='col-lg-12'>
          <section className='panel'>
            <header className='panel-heading flex flex-row justify-between items-center'>
              Announcements
              <div className='flex flex-row flex-wrap gap-3 justify-end items-center'>
                <Button type='button' onClick={() => setShowModal({ status: true })} className='text-white hover:bg-success/90'>
                  Add Announcement
                </Button>
              </div>
              {showModal?.status && (
                <AnnouncementModal
                  setShowModal={setShowModal}
                  item={showModal?.item}
                  action={showModal?.action}
                  saveAnnouncement={saveAnnouncement}
                  deleteAnnouncement={deleteAnnouncement}
                  getAllItemsFromDB={getAllItemsFromDB}
                  wlOptions={wlOptions}
                  cyfAdmin={cyfAdmin}
                  wlAdmin={wlAdmin}
                  user={user}
                />
              )}
            </header>
            <div className='panel-body'>
              <div className='flex flex-row items-center gap-3 justify-end mb-4 flex-wrap'>
                <DatePickerField
                  label='Filter by date'
                  value={filters?.date ?? null}
                  onChange={(date) => setFilters({ ...filters, date })}
                  placeholder='DD/MM/YYYY HH:mm'
                  dateFormat='dd/MM/yyyy h:mm aa'
                  showTimeInput
                  timeInputLabel='Time:'
                  isClearable
                  scrollableYearDropdown
                  yearDropdownItemNumber={5}
                />
                <div className="flex gap-2" role="group">
                  <Button
                    type="button"
                    variant={visibleSections?.includes('upcoming') ? 'default' : 'outline'}
                    className="font-semibold text-sm"
                    style={
                      visibleSections?.includes('upcoming')
                        ? { color: btnTextColor, backgroundColor: primaryButton }
                        : { backgroundColor: '#DDD', color: '#555', fontFamily: font }
                    }
                    onClick={() => setVisibleSections(['upcoming'])}>
                    Upcoming
                  </Button>
                  <Button
                    type="button"
                    variant={visibleSections?.includes('expired') ? 'default' : 'outline'}
                    className="font-semibold text-sm"
                    style={
                      visibleSections?.includes('expired')
                        ? { color: btnTextColor, backgroundColor: primaryButton }
                        : { backgroundColor: '#DDD', color: '#555', fontFamily: font }
                    }
                    onClick={() => setVisibleSections(['expired'])}>
                    Expired
                  </Button>
                </div>

                <div className="flex gap-2" role="group">
                  <Button
                    type="button"
                    variant={viewType === 'card' ? 'default' : 'outline'}
                    size="icon"
                    className="p-5 font-semibold text-sm"
                    style={
                      viewType === 'card'
                        ? { color: btnTextColor, backgroundColor: primaryButton }
                        : { backgroundColor: '#DDD', color: '#555', fontFamily: font }
                    }
                    onClick={() => setViewType('card')}>
                    <LayoutList size={20} strokeWidth={1.5} />
                  </Button>
                  <Button
                    type="button"
                    variant={viewType === 'list' ? 'default' : 'outline'}
                    size="icon"
                    className="p-5 font-semibold text-sm"
                    style={
                      viewType === 'list'
                        ? { color: btnTextColor, backgroundColor: primaryButton }
                        : { backgroundColor: '#DDD', color: '#555', fontFamily: font }
                    }
                    onClick={() => setViewType('list')}>
                    <List size={20} strokeWidth={1.5} />
                  </Button>
                </div>
              </div>
              <hr className='my-4'></hr>

              {visibleSections?.includes('upcoming') && (
                <>
                  <h4 className='flex justify-center w-full font-semibold'>Upcoming Announcements</h4>
                  <hr className='my-3'></hr>
                  {upcomingAnnouncements?.length > 0 ? (
                    <>
                      <div className='overflow-x-auto mb-4'>
                        <table className='app-table'>
                          <thead>
                            <tr>
                              {viewType === 'card' ? (
                                <>
                                  <th style={{ width: '80%', textAlign: 'center' }}>Announcement</th>
                                  <th style={{ width: '20%', textAlign: 'center' }}>Actions</th>
                                </>
                              ) : (
                                <>
                                  <th style={{ width: '40%' }}>Announcement</th>
                                  <th style={{ width: '15%', display: cyfAdmin ? 'table-cell' : 'none' }}>
                                    Target Audience
                                  </th>
                                  <th style={{ width: '15%' }}>Start Date</th>
                                  <th style={{ width: '15%' }}>End Date</th>
                                  <th style={{ width: '15%' }}>Actions</th>
                                </>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {upcomingAnnouncements?.map((item, index) => (
                              <tr key={index}>
                                {viewType === 'card' ? (
                                  <td>
                                    <AnnouncementAlert item={{ ...item }} />
                                  </td>
                                ) : (
                                  <>
                                    <td>{parseAndBuildClickable(item?.text)}</td>
                                    <td style={{ display: cyfAdmin ? 'table-cell' : 'none' }}>
                                      {item?.targetAudience === 'all'
                                        ? 'All Users'
                                        : item?.targetAudience === 'admins'
                                          ? 'White Label / Consultant Admins'
                                          : item?.targetAudience === 'whitelabels'
                                            ? 'White Labels'
                                            : item?.targetAudience}
                                    </td>
                                    <td>{new Date(item?.startDate)?.toLocaleString()}</td>
                                    <td>{new Date(item?.endDate)?.toLocaleString()}</td>
                                  </>
                                )}
                                <td style={{ verticalAlign: 'middle' }}>
                                  <div
                                    className={`${user?.whiteLabelAdmin === item?.editableBy || cyfAdmin ? 'flex' : 'hidden'} flex-row items-center gap-5 flex-wrap ${viewType == 'card' && 'justify-center'} `}>
                                    <button
                                      onClick={() => setShowModal({ status: true, item: item })}
                                      title='Edit Announcement'>
                                      <Pencil size={20} strokeWidth={1.5} />
                                    </button>
                                    <button
                                      title='Delete Announcement'
                                      onClick={() => {
                                        setShowModal({ status: true, item: item, action: 'delete' });
                                      }}>
                                      <Trash2 size={20} strokeWidth={1.5} />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <div className='flex justify-center items-center mb-8'>
                      <p>No Upcoming Announcements</p>
                    </div>
                  )}
                </>
              )}

              {visibleSections?.includes('expired') && (
                <>
                  <h4 className='flex justify-center w-full font-semibold'>Expired Announcements</h4>
                  <hr className='my-3'></hr>
                  {expiredAnnouncements?.length > 0 ? (
                    <div className='overflow-x-auto'>
                      <table className='app-table'>
                        <thead>
                          <tr>
                            {viewType === 'card' ? (
                              <>
                                <th style={{ width: '80%', textAlign: 'center' }}>Announcement</th>
                                <th style={{ width: '20%', textAlign: 'center' }}>Actions</th>
                              </>
                            ) : (
                              <>
                                <th style={{ width: '40%' }}>Announcement</th>
                                <th style={{ width: '15%', display: cyfAdmin ? 'table-cell' : 'none' }}>Target Audience</th>
                                <th style={{ width: '15%' }}>Start Date</th>
                                <th style={{ width: '15%' }}>End Date</th>
                                <th style={{ width: '15%' }}>Actions</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {expiredAnnouncements?.map((item, index) => (
                            <tr key={index}>
                              {viewType === 'card' ? (
                                <td>
                                  <AnnouncementAlert item={{ ...item }} />
                                </td>
                              ) : (
                                <>
                                  <td>{parseAndBuildClickable(item?.text)}</td>
                                  <td style={{ display: cyfAdmin ? 'table-cell' : 'none' }}>
                                    {item?.targetAudience === 'all'
                                      ? 'All Users'
                                      : item?.targetAudience === 'admins'
                                        ? 'White Label / Consultant Admins'
                                        : item?.targetAudience === 'whitelabels'
                                          ? 'White Labels'
                                          : item?.targetAudience}
                                  </td>
                                  <td>{new Date(item?.startDate)?.toLocaleString()}</td>
                                  <td>{new Date(item?.endDate)?.toLocaleString()}</td>
                                </>
                              )}
                              <td style={{ verticalAlign: 'middle' }}>
                                <div
                                  className={`${user?.whiteLabelAdmin === item?.editableBy || cyfAdmin ? 'flex' : 'hidden'} flex-row items-center gap-5 flex-wrap ${viewType == 'card' && 'justify-center'} `}>
                                  <button
                                    onClick={() => setShowModal({ status: true, item: item })}
                                    title='Edit Announcement'>
                                    <Pencil size={20} strokeWidth={1.5} />
                                  </button>
                                  <button
                                    title='Delete Announcement'
                                    onClick={() => {
                                      setShowModal({ status: true, item: item, action: 'delete' });
                                    }}>
                                    <Trash2 size={20} strokeWidth={1.5} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className='flex justify-center items-center'>
                      <p>No Expired Announcements</p>
                    </div>
                  )}
                </>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const announcements = state?.admin?.adminPortal?.announcements;
  const font = state?.branding?.fonts?.[0]?.font?.body;
  const { primaryButton, btnTextColor, buttonHover } = state?.branding?.colors || {};
  const whiteLabels = state.admin?.adminPortal?.whiteLabelSettings;
  const wlOptions = _.sortBy(whiteLabels?.map((wl) => ({ value: wl.whiteLabelId, label: wl.name })) || [], ['label']);
  const cyfAdmin = state?.profile?.details?.cyfAdmin || false;
  const wlAdmin = state?.profile?.details?.whiteLabelAdmin || false;
  const user = state?.profile?.details;
  return {
    announcements,
    font,
    primaryButton,
    btnTextColor,
    wlOptions,
    cyfAdmin,
    wlAdmin,
    user,
    buttonHover,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllItemsFromDB: (table, filter, force) => dispatch(ADMINACTIONS.getAllItemsFromDB(table, filter, force)),
    saveAnnouncement: (item) => dispatch(ACTIONS.saveAnnouncement(item)),
    deleteAnnouncement: (id) => dispatch(ACTIONS.deleteAnnouncement(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Announcement);
